import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home';
import Contact from '@/pages/Contact';
import About from '@/pages/About';
import Blog from '@/pages/Blog';
import NotFound from '@/pages/NotFound';

import Solutions from '@/pages/Solutions';
import Edu from '@/pages/solutions/Edu';
import Com from '@/pages/solutions/Com';
import Est from '@/pages/solutions/Est';
import Vis from '@/pages/solutions/Vis';
import Pro from '@/pages/solutions/Pro';

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  linkActiveClass: 'active',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      
    },
    {
      path: '/sobre',
      name: 'Sobre',
      component: About,
    },
    {
      path: '/solucoes',
      name: 'Soluções',
      component: Solutions,
    },
    {
      path: '/solucoes/educacionais',
      name: 'Soluções educacionais',
      component: Edu,
    },
    {
      path: '/solucoes/gestao-de-estagios',
      name: 'Gestão de Estágios',
      component: Est,
    },
    {
      path: '/solucoes/comunicacao-institucional',
      name: 'Comunicação Institucional',
      component: Com,
    },
    {
      path: '/solucoes/visualizacao-de-dados',
      name: 'Visualização de Dados',
      component: Vis,
    },
    {
      path: '/solucoes/projetos-personalizados',
      name: 'Projetos personalizados',
      component: Pro,
    },
    {
      path: '/contato',
      name: 'Contato',
      component: Contact,
    },
    // {
    //   path: '/blog',
    //   name: 'Blog',
    //   component: Blog,
    // },
    {
      path: '*',
      name: 'Não encontrado',
      component: NotFound,
    },
  ]
});



// WEBPACK FOOTER //
// ./src/routes/index.js